import ReadOnlyParameterValue from './ReadOnlyParameterValue'

export default ReadOnlyParameterValue
